<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon color-gray"
              >
                <font-awesome-icon icon="people-group" />
              </span>
            </template>
            <h3>{{ summary.team_group_name }}</h3>
          </div>
          <div class="mg-b-8">
            <span class="header-date">Created  <span class="number-color number-fontsize">{{ summary.created_at }}</span></span>
            <!--            <span class="header-date">Last Login  <span class="number-color number-fontsize">{{ teamLeaderData.last_login }}</span></span>-->
          </div>
        </div>
      </div>
      <el-tabs
        v-model="activeTab"
      >
        <el-tab-pane
          v-for="(item, index) in month"
          :key="index"
          :name="item.quarter"
        >
          <span slot="label">
            <span>
              <font-awesome-icon
                class="icon"
                icon="bullseye"></font-awesome-icon>
              <span>{{item.value}}</span>
            </span>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">

          <div class="show-data__container">
            <span class="title">Quarterly Settlement Date <span class="date">{{quarter_data.value}}</span></span>
            <ul>
              <li>
                <p>Total Policy</p>
                <p>{{summary.policy_num}}</p>
              </li>
              <li>
                <p>Total Payable</p>
                <p>{{summary.premium | formatMoney(2, false)}}</p>
              </li>
            </ul>
          </div>
          <div class="flex-sb-center">
            <div class="form-item flex-1">
              <span>Search</span>
              <v-input
                v-model="search"
                placeholder="Mobile No. / Name"
                @keyEnter="filterData"
              />
            </div>
            <div class="form-item flex-1">
              <span>Status</span>
              <v-select
                v-model="stts"
                :list="sttsList"
                @change="filterData"
              />
            </div>
            <v-button
              gray
              icon="qrcode"
              @click="showQrcCode">Team Code</v-button>
          </div>
          <div class="detail">
            <div class="table">
              <div class="tr th">
                <span class="width-55 display-none">
                  <span
                    v-show="false"
                    class="display-none">TEAM</span>
                </span>
                <span>Joining Date</span>
                <span>Team Member</span>
                <span>No. of Policy</span>
                <span>Payable HK$</span>
              </div>
              <template v-if="tableData.length>0||team_head_data">
                <div
                  v-if="team_head_data"
                  class="tr"
                  :class="{'trans_bg':tableData.length<=0,'color-gray04':!team_head_data.upgraded}"
                >
                  <span  class="summary_tr width-55">
                    <span class="icon-user">
                      <font-awesome-icon
                        icon="horse-head"></font-awesome-icon>
                    </span>
                  </span>
                  <span  class="summary_tr">
                    <!--                    {{team_head_data.join_at}}-->
                    <div class="time-text">
                      <p>{{ changeTime(team_head_data.join_and_leave)[1] }}</p>
                      <p> {{ changeTime(team_head_data.join_and_leave)[2] }}</p>
                    </div>
                  </span>
                  <span  class="summary_tr">
                    <div class="flex">
                      <span>
                        <span>{{team_head_data.name}}</span>
                        <span class="tr_contact">{{team_head_data.contact}}</span>
                      </span>
                    </div>
                  </span>
                  <span  class="summary_tr">{{team_head_data.policy_num}}</span>
                  <span  class="summary_tr">{{team_head_data.premium|formatMoney(2,false)}}</span>
                </div>
                <div
                  v-for="(item,index) in tableData"
                  :key="'table_tr'+index"
                  class="tr_table">
                  <div
                    class="tr"
                    :class="{'color-gray04':!item.upgraded}">
                    <span  class="summary_tr width-55">
                      <span class="icon-user">
                        <font-awesome-icon
                          icon="user"></font-awesome-icon>
                      </span>
                    </span>
                    <span  class="summary_tr ">
                      <div class="flex-algin time-text">
                        <p>{{ changeTime(item.join_and_leave)[1] }}</p>
                        <p> {{ changeTime(item.join_and_leave)[2] }}</p>
                      </div>
                      <!--                      {{item.join_and_leave}}-->
                    </span>
                    <span class="summary_tr">
                      <div class="flex">
                        <span>
                          <span>{{item.name}}</span>
                          <span class="tr_contact">{{item.contact}}</span>
                        </span>
                      </div>
                    </span>
                    <span  class="summary_tr">{{item.all_policy_num}}</span>
                    <span  class="summary_tr">{{item.all_premium | formatMoney(2, false)}}</span>
                    <span
                      v-if="item.is_next"
                      class="summary_tr icon">
                      <font-awesome-icon
                        v-if="!item.is_open"
                        icon="square-plus"
                        class="icon pointer"
                        @click="handleOpen(item,index)"></font-awesome-icon>
                      <font-awesome-icon
                        v-else
                        icon="square-minus"
                        class="icon pointer"
                        @click="handleOpen(item,index)"></font-awesome-icon>
                    </span>
                  </div>
                  <div
                    v-if="item.is_open"
                    class="tr_more_detail">
                    <div class="tr_contact">{{item.team_members.members}} Members</div>
                    <div>
                      <div>
                        <span
                          class="tr"
                          :class="{'color-gray04':!item.team_members.upgraded}">
                          <span
                            class="flex"
                          >
                            <p class="icon-user">
                              <font-awesome-icon icon="user"></font-awesome-icon>
                            </p>
                            <span>
                              <span>{{item.team_members.name}}</span>
                              <span class="tr_contact">{{item.team_members.contact}}</span>
                            </span>
                          </span>
                          <span  class="summary_tr ">{{item.team_members.policy_num}}</span>
                          <span  class="summary_tr">{{item.team_members.premium|formatMoney(2,false)}}</span>
                        </span>
                        <div
                          v-for="(sec_item,sec_index) in item.team_members.items"
                          :key="'sec_item_'+sec_index"
                          class="tr_second">
                          <div >
                            <div
                              class="tr "
                              :class="{'color-gray04':!sec_item.upgraded}">
                              <span>
                                <span class="flex">
                                  <p class="icon-user">
                                    <font-awesome-icon icon="user-group"></font-awesome-icon>
                                  </p>
                                  <span>
                                    <span>{{sec_item.name}}</span>
                                    <span class="tr_contact">{{sec_item.contact}}</span>
                                  </span>
                                </span>
                              </span>
                              <span  class="summary_tr mg-left-15">{{sec_item.policy_num}}</span>
                              <span  class="summary_tr">{{sec_item.premium|formatMoney(2,false)}}</span>
                            </div>
                          </div>
                          <div
                            v-for="(third_item,third_index) in sec_item.items"
                            :key="'third_item'+third_index"
                            class="tr_third">
                            <div
                              class="tr"
                              :class="{'color-gray04':!third_item.upgraded}">
                              <span>
                                <span class="flex">
                                  <p class="icon-user">
                                    <font-awesome-icon icon="users"></font-awesome-icon>
                                  </p>
                                  <span>
                                    <span>{{third_item.name}}</span>
                                    <span class="tr_contact">{{third_item.contact}}</span>
                                  </span>
                                </span>
                              </span>
                              <span  class="summary_tr mg-left-30">{{third_item.policy_num}}</span>
                              <span  class="summary_tr">{{third_item.premium|formatMoney(2,false)}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  class="tr none_border">
                  <span  class="summary_tr">
                  </span>
                  <span class="el-table__empty-text">No Data</span>
                  <span  class="summary_tr"></span>
                </div>
              </template>
            </div>
            <v-pagination
              :total="pageConfig.total"
              :pageSize="pageConfig.per_page"
              :current="pageConfig.currentPage"
              @currentChange="currentChange" />
          </div>
        </div>
        <div class="right-col">
          <div class="">
            <div
              class="box">
              <div class="flex-sb-center">
                <span class="title">Team Leader</span>
                <span
                  class="blue pointer"
                  @click="handleChange">Edit</span>
              </div>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{customer_profile.id_type==3?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customer_profile.id}}"
                    class="flex flex-wrap text-decoration-none">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                    >{{ customer_profile.isrd_nm }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                    >Unnamed Account &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ customer_profile.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ customer_profile.policys }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="customer_profile.id"
                :phone="customer_profile.phone"
                :customerName="customer_profile.cs_name"
                :email="customer_profile.send_email" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <qr-code
      v-model="showCode"
      is-member
      :form="summary"></qr-code>
    <attach-customer
      ref="attachCustomer"
      :customer-type="1"
      is-all-type
      can-select-all
      is-tier-base
      is-share
      @shareUser="handleSelectCustomer"></attach-customer>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import ContactCustomer from '@/views/components/new-contact-customer'
import {getAccountDetail} from '@api/account'
import {changeSpecialTeam, getSpecialTeamDetailList, getSpecialTeamSummary,getQuarterMonthList} from '@api/team'
import QrCode from '@/views/accounts/components/popup/referral-qr-code'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
export default {
  name: 'TeamDetail',
  components:{
    QrCode,
    ContactCustomer,
    attachCustomer
  },
  mixins: [MixinOptions,MixinFormat],
  data () {
    return {
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      tableData:[],
      team_head_data:{},
      search:'',
      stts:0,
      pageConfig:{
        total: 0,
        currentPage: 1,
        per_page:20
      },
      activeTab:'',
      summary:{},
      month:[],
      customer_profile:{},
      showCode:false,
      showJoinTeam:false,
    }
  },
  computed:{
    changeTime(){
      return (data)=>{
        if(data)
        {
          const match = data.match(/^([^\s]+)\s(.+)$/)
          return match||[]
        }
        return []
      }
    },
    id(){
      return this.$route.params.id
    },
    sttsList(){
      return [
        {id:0,name:'All'},
        {id:1,name:'Active'},
        {id:2,name:'None Active'},
      ]
    },
    quarter_data(){
      let arr =  this.month.filter(item=>item.quarter==this.activeTab)
      return arr[0]||{}
    },
    isShowName(){
      let {cs_name,isrd_lst_nm,isrd_fst_nm} = this.customer_profile
      if(cs_name)
        return cs_name.trim()!=''
      else return  false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    selectData(){
      return [this.id]
    },
    avt_pic(){
      let {avatar_thumb_url} = this.customer_profile||{}
      return avatar_thumb_url || null
    },
  },
  watch:{
    activeTab:{
      immediate:true,
      async handler(val){
        if(val>0){
          await this.network().getSpecialTeamSummary()
          await this.network().getSpecialTeamDetailList()
        }
      }
    }
  },

  async mounted(){
    await this.network().getQuarterMonthList()
    // await this.network().getAccountDetail()
  },
  methods: {
    handleSelectCustomer(user_id,data){
      // this.formData.leader_id = user_id
      let params ={
        leader_id :user_id,
        team_group_id:this.id
      }
      this.network().changeSpecialTeam(params)
      // this.team_head_data = data||{}
    },
    handleChange(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    showQrcCode(){
      this.showCode = true
    },
    async handleOpen(item,index){
      let {team_head,team_members,is_open} = item||{}
      if(team_members){
        this.tableData[index].is_open = !is_open
      }else
        await this.network().getSpecialReferrerDetail({team_head},index)
    },
    format() {
      return ''
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getDetailQuarterList()
    },
    tableRowClassName({row}) {
      let {is_active} = row
      if (!is_active) {
        return 'table-pointer__red'
      }
      return 'table-pointer'
    },
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getSpecialTeamDetailList()
    },
    network(){
      return{
        getSpecialTeamDetailList: async () => {
          const {data} = await getSpecialTeamDetailList({
            team_group_id: this.id,
            quarter:this.activeTab,
            search:this.search,
            stts:this.stts,
            page:this.pageConfig.currentPage
          })
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.per_page = data.per_page
          this.pageConfig.total = data.total
          this.tableData = data.data||[]
          this.tableData.reduce((res,item)=>{
            item.is_open = false
            res.push(item)
            return res
          },[])
          let {team_head_data} = data
          this.team_head_data = team_head_data
        },
        getQuarterMonthList: async () => {
          const {data} = await getQuarterMonthList({
          })
          this.month = data
          let {quarter} = data[0]||{}
          this.activeTab = quarter||''
        },
        getSpecialTeamSummary: async () => {
          if(!this.activeTab) return
          const {data} = await getSpecialTeamSummary({
            team_group_id: this.id,
            quarter:this.activeTab
          })
          this.summary = data
          let {leader_id} = data||{}
          if(leader_id>0)
            this.network().getAccountDetail()
        },
        getAccountDetail: async () => {
          let {leader_id} = this.summary||{}
          const {data} = await getAccountDetail({
            customer_id: leader_id
          })
          this.customer_profile = data.customer_profile
          this.remarkList = data.remark

        },
        changeSpecialTeam: async (params) => {
          const {data} = await changeSpecialTeam(params)
          await this.network().getSpecialTeamSummary()
          await this.network().getSpecialTeamDetailList()
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../assets/css/pay-main-header';
@import '../../../../assets/css/record-detail';
.width-55{
  width: 55px!important;
  flex: 0!important;
  margin-right: 15px;
}
.display-none{
  margin-right: 30px;

}
.time-text{
  font-size: 12px;
  font-weight: 400;
}
</style>
